import { render, staticRenderFns } from "./SmsSend.vue?vue&type=template&id=20e34d1e&scoped=true"
import script from "./SmsSend.vue?vue&type=script&lang=js"
export * from "./SmsSend.vue?vue&type=script&lang=js"
import style0 from "./SmsSend.vue?vue&type=style&index=0&id=20e34d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e34d1e",
  null
  
)

export default component.exports